import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Always render fresh — pre-rendered HTML is for crawlers (no JS),
// users get the full interactive React app. Hydration causes mismatches
// with GSAP, framer-motion, and scroll-triggered animations.
ReactDOM.createRoot(rootElement).render(app);
